import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

const MOBILE_BREAKPOINT = 1025;

class ProductBlockMobileSlider extends HTMLElement {
  private swiper: Swiper | null = null;
  private swiperContainer: HTMLElement | null = null;
  private resizeObserver: ResizeObserver | null = null;
  private resizeTimer: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.swiperContainer = this.querySelector<HTMLElement>(".swiper");

    if (!this.swiperContainer) {
      console.warn("Swiper container not found in product-block-mobile-slider");
      return;
    }

    this.init();
    this.setupResizeHandler();
  }

  disconnectedCallback(): void {
    this.cleanup();
  }

  private init(): void {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    if (isMobile) {
      this.initializeSwiper();
    } else {
      this.destroySwiper();
    }
  }

  private initializeSwiper(): void {
    if (this.swiper || !this.swiperContainer) {
      return;
    }

    try {
      this.swiper = new Swiper(this.swiperContainer, {
        modules: [Scrollbar],
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        slidesPerView: "auto",
        grabCursor: true,
        allowTouchMove: true,
        on: {
          touchStart: (swiper: any) => {
            swiper.allowClick = false;
          },
          touchEnd: (swiper: any) => {
            setTimeout(() => {
              swiper.allowClick = true;
            }, 300);
          },
        },
      });
    } catch (error) {
      console.error("Error initializing Swiper:", error);
    }
  }

  private destroySwiper(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  private setupResizeHandler(): void {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

        if (isMobile && !this.swiper) {
          this.initializeSwiper();
        } else if (!isMobile && this.swiper) {
          this.destroySwiper();
        }
      }, 250);
    });

    this.resizeObserver.observe(document.body);
  }

  private cleanup(): void {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }

    this.destroySwiper();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }
}

if (!customElements.get("product-block-mobile-slider")) {
  customElements.define(
    "product-block-mobile-slider",
    ProductBlockMobileSlider
  );
}

export default ProductBlockMobileSlider;
